import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import Icon from '../../../../icons/Icon';
import { WatchlistEntityRequest, WatchlistGeneralRequest, WatchlistIndividualRequest } from '../../../../domain/watchlist/WatchlistDomains';
import LanguageUtil from '../../../../util/LanguageUtil';

class WatchlistSearchCriteriaModalComponent extends Component<Props> {
  render() {
    const { visible, onClose } = this.props;
    return (
      <Dialog
        header={this.getHeader}
        className={'custom-dialog w-2/5 h-auto'}
        visible={visible}
        onHide={onClose}
        closable={false}
        closeOnEscape={true}
        dismissableMask={true}
      >
        {this.getContent()}
      </Dialog>
    );
  }

  private getHeader = () => {
    return (
      <div className={'bg-[#F9FAFB] h-[54px] rounded-t-[6px] flex items-center justify-between align-center pl-4 border-b'}>
        <div className={'flex items-center justify-start align-center w-full lg:w-auto gap-x-3'}>
          <Icon icon={'search'} className={'text-[#4F4F4F] fill-f-black-2'} size={20} />
          <div className={'!text-f-black-2 font-normal text-md'}>
            {LanguageUtil.get({ id: 'common.label.searchCriteria', defaultMessage: 'Search Criteria' })}
          </div>
        </div>
      </div>
    );
  };

  private getContent = () => {
    const { request } = this.props;
    if (request == undefined) return;
    return (
      <div className={'h-full w-full p-0 m-0'}>
        {Object.entries(request).map((data, index) => {
          return (
            (Array.isArray(data[1]) ? data[1].length != 0 : data[1] != undefined && data[1] != '') && (
              <div className={'flex items-center justify-between p-3 pl-5 border-b text-f-black-2 text-sm'} key={index}>
                <Icon icon={this.getIcon(data[0])} size={16} className={'mr-4'} />
                <span className={'w-1/2'}>{this.formatToName(data[0])}</span>
                <span className={'w-1/2 text-justify overflow-x-scroll'}>{Array.isArray(data[1]) ? data[1].join(',') : data[1]}</span>
              </div>
            )
          );
        })}
      </div>
    );
  };

  private getIcon = (data: string) => {
    switch (data) {
      case 'threshold':
        return 'kyc_sanctionsicon-1';
      case 'name':
        return 'kyc_typeicon';
      case 'identification':
        return 'kyc_identificationnumbericon';
      case 'citizenship':
        return 'kyc_citizenshipsicon';
      case 'dateOfBirth':
        return 'kyc_datesofdeathicon';
      case 'email':
        return 'outline-mail';
      case 'phone':
        return 'outline-phone';
      case 'lists':
        return 'kyc_remarksicon';
      case 'identifier':
        return 'kyc_identificationnumbericon';
      case 'dateOfRegistration':
        return 'kyc_datesofdeathicon';
      case 'id':
        return 'kyc_identificationnumbericon';
      case 'date':
        return 'kyc_datesofdeathicon';
      case 'referenceId':
        return 'kyc_identificationnumbericon';
      default:
        return 'kyc_sanctionsicon-1';
    }
  };

  private formatToName(inputString: string) {
    if (inputString === 'referenceId') {
      return LanguageUtil.get({ id: 'common.label.referenceId', defaultMessage: 'Reference ID' });
    }
    return inputString.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, function (str) {
      return str.toUpperCase();
    });
  }
}

interface Props {
  visible: boolean;
  request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest | undefined;
  onClose: () => void;
}

export default WatchlistSearchCriteriaModalComponent;
